import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetAppointment: IMcAppType = {
  name: "internetAppointment",
  path: "/my/internet/appointment",
  description: "Internet Appointment Booking",
  parameters: {
    properties: {},
  },
  navFlow: NavFlow.FOCUS,
  title: "Request an appointment",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "internetAppointment",
    customerType: CustomerType.kraken,
  },
};
